/* eslint-disable no-console -- Console output is the purpose of this logging transport. */
import dayjs from 'dayjs';
import { saveLog } from './logDB.js';

const levels = ['debug', 'info', 'warn', 'error', 'fatal'];
const timestampFormat = 'YYYY-MM-DD HH:mm:ss.SSS';

const logger = {
	level: import.meta.env.VITE_LOG_LEVEL || 'debug',
	setLevel(newLevel) {
		if (levels.includes(newLevel)) {
			this.level = newLevel;
		}
	},
	log(level, message, additionalData = {}) {
		const timestamp = dayjs().format(timestampFormat);
		const logEntry = {
			timestamp,
			level: level.toUpperCase(),
			message,
			...additionalData
		};

		logEntry.level = level.toUpperCase();
		logEntry.timestamp = timestamp;
		logEntry.message = message;

		if (levels.indexOf(level) >= levels.indexOf(this.level)) {
			console[level](`[${logEntry.timestamp}] [${logEntry.level}]: ${logEntry.message}`, logEntry);

			if (import.meta.env.MODE === 'development') {
				saveLog(logEntry);
			}
			if (import.meta.env.MODE === 'production') {
				console.log('production mode');
				// fetch(url, {
				// 	method: 'POST',
				// 	headers: { 'Content-Type': 'application/json' },
				// 	body: JSON.stringify({
				// 		level,
				// 		message: args.join(' '),
				// 		timestamp: new Date().toISOString()
				// 	})
				// }).catch(console.error);
			}
		}
	},
	debug(message, additionalData) {
		this.log('debug', message, additionalData);
	},
	info(message, additionalData) {
		this.log('info', message, additionalData);
	},
	api(message, additionalData) {
		this.log('api', message, additionalData);
	},
	warn(message, additionalData) {
		this.log('warn', message, additionalData);
	},
	error(message, additionalData) {
		this.log('error', message, additionalData);
	},
	fatal(message, additionalData) {
		this.log('fatal', message, additionalData);
	}
};

export default logger;
